import React from "react";

export default function floatingActionButton({
  color = "#50E3C2",
  ...restProps
}) {
  return (
    <svg
      id="floating_action_button_icon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={45}
      height={45}
      viewBox="0 0 45 45"
      {...restProps}
    >
      <defs>
        <path
          id="b"
          d="M19.5 39C8.73 39 0 30.27 0 19.5S8.73 0 19.5 0C30.269 0 39 8.73 39 19.5S30.269 39 19.5 39z"
        />
        <filter
          id="a"
          width="128.2%"
          height="128.2%"
          x="-11.5%"
          y="-9%"
          filterUnits="objectBoundingBox"
        >
          <feOffset
            dx={1}
            dy={2}
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="1.5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(2 1)">
          <use fill="#000" filter="url(#a)" xlinkHref="#b" />
          <use fill={color} xlinkHref="#b" />
        </g>
        <path
          fill="#FFF"
          d="M19.216 28L18 26.824l6.563-6.316L18 14.174 19.216 13 27 20.51z"
        />
        <path
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19.216 28L18 26.824l6.563-6.316L18 14.174 19.216 13 27 20.51z"
        />
      </g>
    </svg>
  );
}
